import React, { useRef } from "react";
import { CalendarCheck, Heart, ShieldCheck, Users } from "lucide-react";
import { useInView } from "../hooks/useInView";
import { valuePropositions } from "../data/mock";

const iconMap = {
  CalendarCheck,
  Heart,
  ShieldCheck,
  Users,
};

export const ValueProposition = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { threshold: 0.2 });

  return (
    <section
      id="value-proposition"
      ref={sectionRef}
      className="section-padding bg-warm-white relative"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div
          className={`text-center max-w-2xl mx-auto mb-16 ${
            isInView ? "animate-fade-in-up" : "opacity-0"
          }`}
        >
          <span className="text-gold text-sm font-semibold tracking-widest uppercase mb-4 block">
            What Sets Us Apart
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-charcoal mb-6">
            More Than Music.
            <br />
            <span className="text-gold-gradient">We Craft Experiences.</span>
          </h2>
          <p className="text-charcoal/60 text-lg leading-relaxed">
            Every event is unique. We bring the expertise, intuition, and passion
            to ensure yours is nothing short of extraordinary.
          </p>
        </div>

        {/* Value Props Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {valuePropositions.map((prop, index) => {
            const Icon = iconMap[prop.icon];
            return (
              <div
                key={index}
                className={`group p-8 rounded-2xl bg-white border border-border hover:border-gold/30 hover:shadow-xl ${
                  isInView ? "animate-fade-in-up" : "opacity-0"
                }`}
                style={{
                  animationDelay: `${(index + 1) * 150}ms`,
                  animationFillMode: "both",
                  transition: "border-color 0.3s ease, box-shadow 0.3s ease",
                }}
              >
                <div className="w-14 h-14 rounded-xl bg-gold/10 flex items-center justify-center mb-6 group-hover:bg-gold/20" style={{ transition: "background-color 0.3s ease" }}>
                  {Icon && <Icon className="h-7 w-7 text-gold" />}
                </div>
                <h3 className="font-display text-xl font-semibold text-charcoal mb-3">
                  {prop.title}
                </h3>
                <p className="text-charcoal/60 leading-relaxed text-sm">
                  {prop.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
